import * as React from 'react';
import { useContext } from 'react';
import { Button } from '../../shared/ui/button';
import { USER_CONTEXT, UserContext } from './contexts/user_context';
import OpenInNew from './icons/open_in_new';
import { ICON_COLOR } from './menu';

export default function HeaderLinks() {
  const {
    current_camp: { seo_path, seo_path_kx, seo_path_ubook },
  } = useContext<USER_CONTEXT>(UserContext);

  if (!seo_path && !seo_path_kx && !seo_path_ubook) return;

  return (
    <div className={'flex_horizontal middle-width'}>
      {seo_path_kx && (
        <Button href={`https://kurortix.ru${seo_path_kx}`} target={'_blank'} icon={<OpenInNew color={ICON_COLOR} />}>
          Kurortix
        </Button>
      )}
      {seo_path && (
        <Button href={`https://mirturbaz.ru${seo_path}`} target={'_blank'} icon={<OpenInNew color={ICON_COLOR} />}>
          МирТурбаз
        </Button>
      )}
      {seo_path_ubook && (
        <Button href={`https://ubook.ru${seo_path_ubook}`} target={'_blank'} icon={<OpenInNew color={ICON_COLOR} />}>
          Ubook
        </Button>
      )}
    </div>
  );
}
